import * as React from 'react';
import { useTldrawApp } from 'sn-wb-tldraw';

interface CursorSVGProps {
  sticker: string;
}

export function CursorSVG({ sticker }: CursorSVGProps): JSX.Element {
  const app = useTldrawApp();
  const points = app.useStore((s) => s.appState.currentStickerPoint);
  const zoom = app.useStore((s) => s.document.pageStates.page.camera.zoom);
  const pointX =
    (app.useStore((s) => s.document.pageStates.page.camera.point[0]) + points[0]) * zoom - 20;
  const pointY =
    (app.useStore((s) => s.document.pageStates.page.camera.point[1]) + points[1]) * zoom - 10;

  return (
    <div
      style={{
        pointerEvents: 'none',
        position: 'absolute',
        top: '0px',
        left: '0px',
        height: '45px',
        width: '45px',
        transformOrigin: 'center center',
        opacity: '0.5',
        borderRadius: '50%',
        transform: ` translate(${pointX}px, ${pointY}px)`,
      }}
    >
      <img src={sticker} />
    </div>
  );
}
